<template>
  <BaseModalConfirm
    ref="BaseModalConfirmRef"
    :title="$t('limits.gamePause.title')"
    :text="$t('limits.gamePause.subtitle', { pause: get_limitsGamePause ? played.count : '', typetime: played.typetime })"
    :svg="{ name: 'common/warning', style: { color: 'var(--warning-500)' } }"
    no-click-outside
    horizontal-buttons
  >
    <template #controls="{ onCancel }">
      <UiBtn
        color="gray"
        full-width
        :text="$tc('limits.gamePause.submit')"
        @click="closeModal"
      />

      <UiBtn
        color="primary"
        full-width
        :text="$t('limits.gamePause.text', {timer: countdown > 0 ? `(${countdown})` : ''})"
        :disabled="countdown > 0"
        @click="onCancel"
      />
    </template>
  </BaseModalConfirm>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseModalConfirm from '@/components/Base/Modal/Confirm'
import { secToHours, secToMin } from '@/util/helpers/time'

const SEC = 10
let idInterval = null

export default {
  name: 'LimitsModalGamePause',
  components: {
    BaseModalConfirm,
  },
  data() {
    return {
      countdown: SEC,
    }
  },
  computed: {
    ...mapGetters('limits', ['get_limitsGamePause']),
    played() {
      if (!this.get_limitsGamePause) return {}

      const hours = secToHours(this.get_limitsGamePause.user_played)
      const min = secToMin(this.get_limitsGamePause.user_played)
      const isHours = hours > 0

      return {
        count: isHours ? hours : min,
        typetime: isHours ? this.$t('limits.sportHour') : this.$t('limits.sportMin'),
      }
    },
  },
  watch: {
    get_limitsGamePause(val) {
      val && this.$open()
    },
  },
  beforeDestroy() {
    this.act_limitsGamePause(null)
  },
  methods: {
    ...mapActions('limits', [
      'act_limitsGamePause',
    ]),
    $open() {
      this.countdown = this.get_limitsGamePause.pause
      this.$refs.BaseModalConfirmRef.$open()
      this.timer()
    },
    $close() {
      clearInterval(idInterval)
      this.$refs.BaseModalConfirmRef.$close()
      this.act_limitsGamePause(null)
    },
    closeModal() {
      this.$close()
      this.$router.push({ path: this.$paths.home })
      this.act_limitsGamePause(null)
    },
    timer() {
      idInterval = setInterval(() => {
        --this.countdown
        if (this.countdown < 1) {
          clearInterval(idInterval)
        }
      }, 1000)
    },
  },
}
</script>
